import s from './ReferralSlide.module.css'

/**
 * 홈 배너 캐러셀 안의 추천 슬라이드(회의 S5 후속). 운영자 이미지 배너와 같은 5:2 칸에 코드로 그린다 —
 * 왼쪽 두 줄 카피 + 강조 한 줄, 오른쪽 선물 상자 일러스트(이미지 배너의 '카피 좌 / 상품 우' 구성을 따른다).
 */
export function ReferralSlide() {
  return (
    <span className={s.slide}>
      <span className={s.copy}>
        <span className={s.title}>
          지인에게 추천하고
          <br />
          포인트 받으세요
        </span>
        <span className={s.sub}>▸ 링크로 가입한 회사가 주문하면 적립</span>
      </span>
      <span className={s.art} aria-hidden="true">
        <svg viewBox="0 0 120 110" className={s.box}>
          <ellipse cx="60" cy="102" rx="40" ry="5" fill="rgba(0,104,74,0.12)" />
          <rect x="22" y="48" width="76" height="52" rx="6" fill="#00ed64" />
          <rect x="16" y="36" width="88" height="18" rx="5" fill="#00c957" />
          <rect x="53" y="36" width="14" height="64" fill="#001e2b" />
          <path d="M60 36c-8-15-27-17-27-6 0 7 10 6 27 6z" fill="none" stroke="#001e2b" strokeWidth="5" strokeLinejoin="round" />
          <path d="M60 36c8-15 27-17 27-6 0 7-10 6-27 6z" fill="none" stroke="#001e2b" strokeWidth="5" strokeLinejoin="round" />
        </svg>
        <span className={`${s.coin} ${s.coinA}`}>P</span>
        <span className={`${s.coin} ${s.coinB}`}>P</span>
      </span>
    </span>
  )
}
